import { m } from "framer-motion";

const included = [
	"Job stays live until deadline or 30 days",
	"Unlimited deadline edits within 30 days",
	"A dedicated company hiring page",
	"Promotion across our job board, socials, WhatsApp, and email digest",
	"Optional 30-day extension for 29,000 TZS",
];

const noStrings = ["No monthly subscription", "No per-candidate fees", "No account required"];

const EASE = [0.22, 1, 0.36, 1] as [number, number, number, number];

function PricingSection() {
	return (
		<section className="py-20 sm:py-28">
			<m.div
				initial={{ opacity: 0, y: 24 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true, margin: "-80px" }}
				transition={{ duration: 0.7, ease: EASE }}
				className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-16"
			>
				<div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
					{/* Left — value-first */}
					<div className="lg:col-span-7">
						<h3 className="font-plus-jakarta text-[clamp(2.25rem,5vw,3.5rem)] font-bold text-gray-900 leading-[1.05] tracking-tight mb-6 max-w-xl">
							One flat fee.
							<br />
							Everything included.
						</h3>
						<p className="font-inter text-lg text-gray-600 leading-relaxed max-w-md mb-10">
							No setup costs. No monthly subscription. Post a job and reach qualified candidates across Tanzania.
						</p>

						<div className="flex items-baseline gap-2.5 mb-9">
							<span className="font-plus-jakarta text-[2.75rem] sm:text-5xl font-bold text-blue-800 tabular-nums tracking-tight leading-none">
								49,000
							</span>
							<span className="font-inter text-base font-medium text-gray-500">TZS / job</span>
						</div>

						<div className="flex flex-wrap gap-x-6 gap-y-3">
							{noStrings.map((item) => (
								<span key={item} className="inline-flex items-center gap-2 font-inter text-sm text-gray-600">
									<span className="w-1 h-1 rounded-full bg-blue-700" />
									{item}
								</span>
							))}
						</div>
					</div>

					{/* Right — editorial numbered list */}
					<div className="lg:col-span-5 lg:pt-3">
						<p className="font-plus-jakarta text-[13px] font-bold text-gray-900 mb-5">What's included</p>
						<ul className="space-y-0">
							{included.map((feature, i) => (
								<m.li
									key={feature}
									initial={{ opacity: 0, y: 14 }}
									whileInView={{ opacity: 1, y: 0 }}
									viewport={{ once: true, margin: "-40px" }}
									transition={{ duration: 0.5, delay: 0.15 + i * 0.08, ease: EASE }}
									className="flex items-baseline gap-5 py-4 border-b border-gray-100 last:border-0"
								>
									<span className="font-plus-jakarta text-xs font-bold text-blue-700 tabular-nums shrink-0">
										0{i + 1}
									</span>
									<span className="font-inter text-[15px] text-gray-700 leading-relaxed">{feature}</span>
								</m.li>
							))}
						</ul>
					</div>
				</div>
			</m.div>
		</section>
	);
}

export default PricingSection;
